import { render, staticRenderFns } from "./pushViewPage.vue?vue&type=template&id=282bfb27&scoped=true&"
import script from "./pushViewPage.vue?vue&type=script&lang=js&"
export * from "./pushViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282bfb27",
  null
  
)

export default component.exports